const sendLog = (object = '', option = {}, type = 'click') => {
  try {
    const { $h } = window;
    if ($h && typeof $h.a2s !== 'undefined') {
      if (type === 'click') {
        $h.a2s.sendClickLog(object, JSON.stringify(option));
      } else if (type === 'contents') {
        $h.a2s.sendContentsLog(object, JSON.stringify(option));
      }
    }
  } catch (e) {
    console.log(e);
  }
};

export default sendLog;
